export default __webpack_public_path__ + "static/media/oatmealcookies@3x.36dad236.jpg";